import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-check-it-facility-grid',
  templateUrl: './check-it-facility-grid.component.html',
  styleUrls: ['./check-it-facility-grid.component.scss']
})
export class CheckItFacilityGridComponent implements OnInit {
public checkeritfacilitygrid:any=[];
  constructor(public appservice:AppService,public router:Router) { }
  public checker_itfacility_editdata:any=[];
   
  getcheckerITfacilitygrid(){
    this.appservice.getTable("api/Transaction/getcheckerITfacilitygrid").subscribe((res:any)=>{
      this.checkeritfacilitygrid=JSON.parse(res).record;
      console.log("the checkeritfacilitygrid",this.checkeritfacilitygrid)
      return this.checkeritfacilitygrid;
      
    })
  }
  editEmployee(data:any){
    this.appservice.checkeritfacilityedit=data;
    this.router.navigate(["/home/checkeritfacilityedit"]);

  }
  ngOnInit(): void {
    this.checkeritfacilitygrid=this.appservice.getcheckerITfacilitygrid();
    console.log("the checkeritfacilitygrid",this.checkeritfacilitygrid)
  }

}
